import { render, staticRenderFns } from "./ClientUserStatistics.vue?vue&type=template&id=0924f728"
import script from "./ClientUserStatistics.vue?vue&type=script&lang=js"
export * from "./ClientUserStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports